import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef(({ className, variant = "light", ...props }, ref) => {
  const isDark = variant === "dark"
  
  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn("relative flex w-full touch-none select-none items-center cursor-pointer", className)}
      {...props}>
      <SliderPrimitive.Track
        className={cn(
          "relative h-2 w-full grow overflow-hidden rounded-full cursor-pointer",
          isDark ? "bg-white/20" : "bg-blue-100"
        )}>
        <SliderPrimitive.Range
          className={cn(
            "absolute h-full",
            isDark ? "bg-white" : "bg-gradient-to-r from-blue-600 to-blue-700"
          )}
        />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className={cn(
          "block h-5 w-5 rounded-full border-2 bg-white shadow-md transition-all hover:scale-110 hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 cursor-pointer",
          isDark
            ? "border-white focus-visible:ring-white focus-visible:ring-offset-blue-900"
            : "border-blue-700 focus-visible:ring-blue-500"
        )}
      />
    </SliderPrimitive.Root>
  )
})
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
